module.exports = __webpack_public_path__ + "static/media/eye.399cd5d2.png";